$('.base-page-slider').slick({
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: '<div class="base-page-nav prev">\n' +
        '                    <svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
        '                        <path d="M9.14172 1.24946L2.49992 8L9.14258 14.7505L7.90368 16L0.590776 8.62473L-0.000279427 8L0.589916 7.37527L7.90282 0L9.14172 1.24946Z" fill="#FF7D05"/>\n' +
        '                    </svg>\n' +
        '                </div>',
    nextArrow: '<div class="base-page-nav next">\n' +
        '                    <svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
        '                        <path d="M0.000861511 14.7505L6.64266 8L0 1.24946L1.23889 0L8.5518 7.37527L9.14286 8L8.55266 8.62473L1.23975 16L0.000861511 14.7505Z" fill="#FF7D05"/>\n' +
        '                    </svg>\n' +
        '                </div>',
    responsive: [
        {
            breakpoint: 1181,
            settings: {
                slidesToShow: 2,
            }
        },
    ]
});
